import { Column } from 'primereact/column'
import { DataTable } from 'primereact/datatable'
import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { tableCellCentered } from '../../../../assets/js/styles'
import {
  Btn,
  CustomDataTableHeader,
  CustomDropdown,
  CustomPanel,
  PageHeader,
} from '../../../../components'
import {
  hideLoadingBox,
  showLoadingBox,
  showMessageBox,
} from '../../../../store/actions/system.actions'
import useSaldoPatrimonialPorOperacao, { LOAD_MESSAGE } from './SaldoPatrimonialPorOperacaoHook'

function SaldoPatrimonialPorOperacao({ dispatch, history, selectedTp }) {
  const { state, localDispatch } = useSaldoPatrimonialPorOperacao()

  useEffect(() => {
    localDispatch.onInit()
  }, [selectedTp])

  useEffect(() => {
    switch (state.loadingMessage) {
      case LOAD_MESSAGE.NONE:
        dispatch(hideLoadingBox())
        break

      case LOAD_MESSAGE.GET_DATA:
        dispatch(showLoadingBox('Aguarde...', state.loadingMessage))
        localDispatch.getReportData(selectedTp)
        break

      default:
        break
    }
  }, [state.loadingMessage])

  useEffect(() => {
    if (state.errorMessage) {
      dispatch(showMessageBox(null, state.errorMessage))
      localDispatch.resetState()
    }
  }, [state.errorMessage])

  return (
    <>
      <PageHeader>6.6 - Saldo Patrimonial por Operação</PageHeader>
      <div style={{ marginTop: 20 }}>
        <CustomPanel showBtnNovo={false} onVoltar={history.goBack}>
          <div className="p-grid p-align-end">
            <div className="p-col-3">
              <CustomDropdown
                label={'Donos de Patrimonio'}
                optionLabel={'name'}
                value={state.selectedDono}
                options={state.donos}
                onChange={localDispatch.onChageDono}
                marginTop={20}
              />
            </div>
            <div className="p-col-4" style={{ display: 'inline-block', marginLeft: 10 }}>
              <Btn onClick={() => localDispatch.onBtnExportarExcel(state.saldos)}>
                Exportar Excel
              </Btn>
            </div>
            <div className="p-col-12">
              <DataTable
                value={state.saldos}
                emptyMessage={'Não existe movimentação para o Período selecionado'}
                paginator={true}
                rows={10}
                header={<CustomDataTableHeader onChange={localDispatch.onGlobalFilterChange} />}
                globalFilter={state.globalFilter}
              >
                <Column field={'tp_name'} header={'Op. Logístico'} style={tableCellCentered(120)} />
                <Column field={'dono_patrimonio'} header={'Dono'} style={tableCellCentered(120)} />
                <Column
                  field={'patrimonio_ativo_name'}
                  header={'Patrimonio'}
                  style={tableCellCentered(120)}
                />
                <Column field={'total_fisico'} header={'Fisíco'} style={tableCellCentered(120)} />
                <Column
                  field={'total_em_transito'}
                  header={'Em Transito'}
                  style={tableCellCentered(120)}
                />
                <Column field={'total'} header={'Total'} style={tableCellCentered(120)} />
              </DataTable>
            </div>
          </div>
        </CustomPanel>
      </div>
    </>
  )
}

const mapStateToProps = ({ system: { selectedTp } }) => ({ selectedTp })

export default connect(mapStateToProps)(withRouter(SaldoPatrimonialPorOperacao))
